import { ICompany } from "./../../../interfaces/company";
import { MatDialog } from "@angular/material";
import { Component, OnInit } from "@angular/core";

import { IRole } from "src/app/interfaces/role";
import { IGroup } from "src/app/interfaces/group";
import { RoleEntryComponent } from "./role-entry/role-entry.component";
import { RoleService } from "src/app/services/http/business/role/role.service";
import { GroupService } from "src/app/services/http/business/group/group.service";
import { GroupRoleService } from "src/app/services/http/business/groupRole/group-role.service";

@Component({
  selector: "app-roles",
  templateUrl: "./roles.component.html",
  styleUrls: ["./roles.component.css"]
})
export class RolesComponent implements OnInit {
  gList: IGroup;
  sList: IRole;
  rDetail: IRole;
  groupList: any;
  companyList: ICompany;
  hideDetail: boolean = true;
  constructor(
    private dialog: MatDialog,
    private roleService: RoleService,
    private groupService: GroupService,
    private groupRoleService: GroupRoleService
  ) { }

  ngOnInit() {
    this.roleService.change.subscribe(() => { });
    this.roleService.hideDeatail.subscribe(() => {
      this.hideDetail = true;
    });
  }

  selected(rID: number) {
    if (rID) {
      this.hideDetail = false;
      this.roleService.getById(rID).subscribe(res => {
        this.rDetail = res;
      });
      this.groupRoleService.getById(rID).subscribe(res => {
        this.sList = res;
      });
      this.groupService.list(0, 0).subscribe(res => {
        this.gList = res.DataList;
      });
    }
  }

  add() {
    this.dialog
      .open(RoleEntryComponent)
      .afterClosed()
      .subscribe(() => {
        this.roleService.fire();
        this.roleService.hide();
      });
  }
}
